/* Hooks */
import useRequest from './useRequest';
import useDeleteUnusedRequest from './useDeleteUnusedRequest';

export default function useRequestAndDelete(requestId: string) {
  useDeleteUnusedRequest(requestId);
  return useRequest(requestId);
}
